import React, { Component } from "react";
import { Col, Image } from "react-bootstrap";

class Renovation extends Component {
    render() {
        const query = new URLSearchParams(this.props.data);
        query.delete('attachments');
        let renovation_url = "/renovation-detail/" + this.props.data.id  + "?" + query.toString();

        const renovation_image = (this.props.data.attachments) && !this.props.data.attachments.includes("default.jpg")?
            this.props.data.attachments :
            process.env.REACT_APP_BASE_URL + "/images/default/renovation.jpg";

        return (
            <Col md={6} className="items web info-overlay mb-50">
                <div className="item-img o-hidden">
                    <a href={renovation_url} className="imago wow">
                        <div className="inner wow">
                            <Image src={renovation_image} alt="image"/>
                        </div>
                    </a>
                    <div className="info">
                        <h5><a href={renovation_url}>{this.props.data.name}</a></h5>
                    </div>
                </div>
            </Col>
        );
    }
}

export default Renovation;
